import { stableKey } from '../../../lib';

export const templateSelectionKeys = {
  all: ['templateSelection'] as const,

  mutations: {
    updateTheme: () => stableKey(['templateSelection', 'updateTheme']),
    createSite: () => stableKey(['templateSelection', 'createSite']),
    setupProducts: () => stableKey(['templateSelection', 'setupProducts']),
  },
} as const;
